export const appConfigMapping = {
  flex: {
    stage: (<any>window).appConfig.flex.stage,
  }
};
